export enum ComplianceTags {
  GDPR = 'GDPR',
  PII = 'PII',
  PHI = 'PHI'
}

export enum ComplianceRoles {
  MANAGER = 'manager',
  ADMIN = 'admin',
  USER = 'user'
}

export enum ComplianceWorkflows {
  EXPIRY_MAIL = 'expiry_mail',
  REACHING_DUE_DATE = 'reaching_due_data'
}

